// assets
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  LogoutOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

// Функция для получения меню аутентификации
export const getAuthMenuItems = (isAuthenticated) => {
  if (isAuthenticated) {
    return {
      id: 'authentication',
      title: 'Аутентификация',
      type: 'group',
      children: [
        {
          id: 'logout',
          title: 'Выход',
          type: 'item',
          url: '/logout',
          icon: icons.LogoutOutlined,
          target: true
        }
      ]
    };
  } else {
    return {
      id: 'authentication',
      title: 'Аутентификация',
      type: 'group',
      children: [
        {
          id: 'login',
          title: 'Вход',
          type: 'item',
          url: '/login',
          icon: icons.LoginOutlined,
          target: true
        }
      ]
    };
  }
};

// Дефолтное меню для неаутентифицированных пользователей
const pages = {
  id: 'authentication',
  title: 'Аутентификация',
  type: 'group',
  children: [
    {
      id: 'login',
      title: 'Вход',
      type: 'item',
      url: '/login',
      icon: icons.LoginOutlined,
      target: true
    }
  ]
};

export default pages;
